import { FormControlProps } from '@/domain/mitarbeiter/features/anlageassistent/components/form/types';
import { InfoButton } from '@/domain/mitarbeiter/features/anlageassistent/components/InfoButton';
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldError,
  FieldLabel,
} from '@e2n/ui/v2';
import { ReactNode } from 'react';
import { useFieldContext } from '../hooks';

type FormBaseProps = FormControlProps & {
  children: ReactNode;
  horizontal?: boolean;
  controlFirst?: boolean;
};

// oxlint-disable-next-line complexity
export function FieldBase({
  children,
  label,
  isRequired,
  description,
  horizontal,
  infoText,
  className,
}: FormBaseProps) {
  const field = useFieldContext();
  const isInvalid = !field.state.meta.isValid;
  const hasWarning =
    // @ts-expect-error Es gibt aktuell leider noch keine Möglichkeit Typescript mitzuteilen, dass
    // das Tanstack MetaField um eine Custom Property erweitert wurde, daher übergangsweise der harte Weg
    // s. https://github.com/TanStack/form/issues/1111
    field.state.meta.isTouched && field.state.meta.warnings;
  const warnings: Array<{ message: string }> | undefined =
    // @ts-expect-error Es gibt aktuell leider noch keine Möglichkeit Typescript mitzuteilen, dass
    // das Tanstack MetaField um eine Custom Property erweitert wurde, daher übergangsweise der harte Weg
    // s. https://github.com/TanStack/form/issues/1111
    field.state.meta.warnings;

  let errorElement = hasWarning && (
    <FieldError errors={warnings} variant={'warning'} />
  );

  errorElement = isInvalid ? (
    <FieldError errors={field.state.meta.errors} />
  ) : (
    errorElement
  );

  return (
    <Field
      data-invalid={isInvalid}
      className={className}
      orientation={horizontal ? 'horizontal' : undefined}>
      <FieldContent>
        {label && (
          <FieldLabel
            htmlFor={field.name}
            invalid={isInvalid}
            requiredField={isRequired}
            infoButton={infoText ? <InfoButton>{infoText}</InfoButton> : null}>
            {label}
          </FieldLabel>
        )}
        <FieldDescription>{description}</FieldDescription>
      </FieldContent>
      {children}
      {errorElement}
    </Field>
  );
}
